import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MwButton, MwInputText } from "../ui/";
import TagListItem from "./TagListItem";

const TagList = ({
  tagList,
  setTagList,
  withLabel = false,
  label = "Tags", // قيمة افتراضية
  classNamePrivate,
  disabled = false,
}) => {
  const [t] = useTranslation("global");
  const [inputTag, setInputTag] = useState("");

  const removeTag = (tag) => {
    if (disabled) return;
    setTagList(tagList.filter((t) => t !== tag));
  };

  const addTag = () => {
    if (disabled) return;
    if (!inputTag.trim()) return;
    if (!tagList.includes(inputTag)) {
      setTagList([...tagList, inputTag]);
      setInputTag("");
    }
  };

  const onKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter") addTag();
  };

  return (
    <div className="flex-1 mt-1 relative ">
      {withLabel && (
        <label className="block text-xs font-bold text-[#261759]">
          {label}
        </label>
      )}
      
      <div className="relative">
        <MwInputText
          value={inputTag}
          onChange={(e) => setInputTag(e.target.value)}
          onKeyDown={onKeyDown}
          disabled={disabled}
          placeholder={t("invoice.enterTagName") || "Tag Name"}
          classNameInput={`w-full relative  ${classNamePrivate} pr-8`}
        />
        
        <MwButton
          actionType="button"
          type="secondary"
          size="sm"
          classNameCustom="absolute top-1/2 end-2 -translate-y-1/2 border-none p-1"
          onClick={addTag}
          disabled={disabled}
        >
          <img 
            src="/assets/icons/add.png" 
            alt="Add tag" 
            className="w-4 h-4" 
          />
        </MwButton>
      </div>
      
      <div className="flex flex-wrap absolute top-15  text-sm gap-1">
        {tagList?.map((tag, index) => (
          <TagListItem
            key={index}
            tag={tag}
            removeTagHandler={() => removeTag(tag)}
          />
        ))}
      </div>
    </div>
  );
};

export default TagList;
